import * as Yup from "yup";

export const paymentInformation = () => {
  return Yup.object().when("verificationStatus", {
    is: (verificationStatus: number) => verificationStatus !== 1,
    then: () =>
      Yup.object().shape({
        receivePayment: Yup.string()
          .oneOf(["e-transfer", "in-person"], "Please select a payment method")
          .required("Payment method is required"),
        usePersonalEmail: Yup.boolean().required(),
        email: Yup.string().when(["usePersonalEmail", "receivePayment"], {
          is: (usePersonalEmail: boolean, receivePayment: string) =>
            usePersonalEmail === false && receivePayment === "e-transfer",
          then: () =>
            Yup.string()
              .email("Please enter a valid email address")
              .required("Email is required"),
          otherwise: () => Yup.string().nullable(),
        }),
        confirmEmail: Yup.string().when(
          ["usePersonalEmail", "receivePayment"],
          {
            is: (usePersonalEmail: boolean, receivePayment: string) =>
              usePersonalEmail === false && receivePayment === "e-transfer",
            then: () =>
              Yup.string()
                .oneOf([Yup.ref("email")], "Email addresses must match")
                .required("Please confirm your email"),
            otherwise: () => Yup.string().nullable(),
          }
        ),
        receiveETransfer: Yup.string().when("receivePayment", {
          is: "e-transfer",
          then: () =>
            Yup.string()
              .oneOf(
                ["email", "mobile", "bankAccount"],
                "Please select mobile or bank account"
              )
              .required("Please select how to receive e-transfer"),
          otherwise: () => Yup.string().nullable(),
        }),
        usePersonalNumber: Yup.boolean().required(),
        mobile: Yup.string().when(
          ["receiveETransfer", "usePersonalNumber", "receivePayment"],
          {
            is: (
              receiveETransfer: string,
              usePersonalNumber: boolean,
              receivePayment: string
            ) =>
              receiveETransfer === "mobile" &&
              !usePersonalNumber &&
              receivePayment !== "in-person",
            then: () =>
              Yup.string()
                .matches(
                  /^\(\d{3}\) \d{3}-\d{4}$/,
                  "Enter a valid 10-digit Canadian number."
                )
                .required("Mobile number is required"),
            otherwise: () => Yup.string().nullable(),
          }
        ),
        confirmMobile: Yup.string().when(
          ["receiveETransfer", "usePersonalNumber", "receivePayment"],
          {
            is: (
              receiveETransfer: string,
              usePersonalNumber: boolean,
              receivePayment: string
            ) =>
              receiveETransfer === "mobile" &&
              !usePersonalNumber &&
              receivePayment !== "in-person",
            then: () =>
              Yup.string()
                .oneOf([Yup.ref("mobile")], "Mobile numbers must match")
                .required("Please confirm your mobile number"),
            otherwise: () => Yup.string().nullable(),
          }
        ),
        institutionNumber: Yup.string().when("receiveETransfer", {
          is: "bankAccount",
          then: () =>
            Yup.string()
              .matches(/^\d{3}$/, "Institution number must be 3 digits")
              .required("Institution number is required"),
          otherwise: () => Yup.string().nullable(),
        }),
        transitNumber: Yup.string().when("receiveETransfer", {
          is: "bankAccount",
          then: () =>
            Yup.string()
              .matches(/^\d{5}$/, "Transit number must be 5 digits")
              .required("Transit number is required"),
          otherwise: () => Yup.string().nullable(),
        }),
        bankAccount: Yup.string().when("receiveETransfer", {
          is: "bankAccount",
          then: () =>
            Yup.string()
              .matches(/^\d{7,12}$/, "Bank account must be 7-12 digits")
              .required("Bank account number is required"),
          otherwise: () => Yup.string().nullable(),
        }),
        confirmBankAccount: Yup.string().when("receiveETransfer", {
          is: "bankAccount",
          then: () =>
            Yup.string()
              .oneOf(
                [Yup.ref("bankAccount")],
                "Bank account numbers must match"
              )
              .required("Please confirm your bank account number"),
          otherwise: () => Yup.string().nullable(),
        }),
      }),
  });
};
